import Section from '@/models/Section';
import Content from '@/models/Content';
import SimpleChecklistItem from '@/models/SimpleChecklistItem';
import Formatter from '@/functions/Formatter';

const state = {
    article: {}
}

const mutations = {
    SET_ARTICLE(state, article){
        state.article = article; 
    },
    EDIT_ARTICLE_TITLE(state, payload){
        state.article.title = payload.title;
        state.article.alias = payload.alias;
    },
    EDIT_ARTICLE_IMAGE(state, image){
        state.article.feature_image = image;
    },
    ADD_SECTION(state, section){    
        state.article.sections?.push(section);
    },
    EDIT_SECTION(state, section){
        let sectionIndex = state.article.sections.findIndex(s => s.id == section.id);
        state.article.sections[sectionIndex] = section;
    },   
    DELETE_SECTION(state, section){
        state.article.sections = state.article.sections.filter(s => s.id != section.id)
    },
    SET_CATEGORIES(state, categories){
        state.article.categories = categories;
    },
    SET_ACCESS_GROUPS(state, accessGroups){
        state.article.access_groups = accessGroups;
    },
    SET_SECURITY_GROUPS(state, securityGroups){
        state.article.security_groups = securityGroups;
    },
    SET_TAGS(state, tags){
        state.article.tags = tags;
    }
}

const actions = {
    //#region article
    initArticleEdit({commit, rootGetters }, id){
        let article = rootGetters.getArticleById(id);
        commit('SET_ARTICLE', article);
    },
    updateArticleTitle({commit}, title){
        let alias = Formatter.createAlias(title)
        let payload = { title: title, alias: alias };
        commit('EDIT_ARTICLE_TITLE', payload );
    },
    updateArticle({commit}, article){
        commit('SET_ARTICLE', article);
    },
    clearArticleEdit({commit}){
        commit('SET_ARTICLE', {});
    },
    //#endregion
    //#region section  
    addNewSection({commit}){
        let section = new Section(Date.now());
       
        commit('ADD_SECTION', section);
        
        return section;
    },
    updateSection({commit}, section){
        commit('EDIT_SECTION', section)
    },
    deleteSection({commit}, section){
        commit('DELETE_SECTION', section);
    },
    //#endregion
    //#region content
    addNewContent({commit}, payload){
        let section = payload.section;
        let contentType = payload.type;
        let contentId = Date.now();
        let content = new Content(contentType, contentId, section.id);

        section.contents.push(content);
        commit('EDIT_SECTION', section);
        return content;
    },
    updateContent({commit, getters}, content){
        let section = getters.getSectionById(content.section_id);
        let contentIndex = section.contents.findIndex(c => c.id == content.id);

        section.contents[contentIndex] = content;
        commit('EDIT_SECTION', section); 
    },
    deleteContent({commit}, payload){
        let content = payload.content;
        let section = payload.section;

        section.contents = section.contents.filter(c => c.id != content.id);
        commit('EDIT_SECTION', section);
    },
    addNewChecklistItem({dispatch}, content){
        content.items.push(new SimpleChecklistItem(Date.now(), content.id));

        dispatch('updateContent', content);
    },
    removeChecklistItem({dispatch}, payload){
        let item = payload.item;
        let content = payload.content;
        
        content.items = content.items.filter(i => i.id != item.id);
        dispatch('updateContent', content);
    },
    ////#endregion
    updateCategories({commit}, categories){
        commit('SET_CATEGORIES', categories);
    },
    updateAccessGroups({commit}, accessGroups){
        commit('SET_ACCESS_GROUPS', accessGroups);
    },
    updateSecurityGroups({commit}, securityGroups){
        commit('SET_SECURITY_GROUPS', securityGroups);
    },
    updateTags({commit}, tags){
        commit('SET_TAGS', tags)
    },
    async uploadArticleImage({commit, state, dispatch}, image){
        let payload = { refId : state.article.id, field: 'feature_image', ref: 'article', image: image };
        let response = await dispatch('uploadImageWithRef', payload,  { root:true });
        commit('EDIT_ARTICLE_IMAGE', response);

        return response;
    },
    async uploadContentImage({dispatch}, payload){
        let response = await dispatch('uploadImage', payload.image, { root:true });
        payload.content.image_id = response.id;
        dispatch('updateContent', payload.content);

        return response;
    },
    async uploadContentFiles({dispatch}, payload){
        let content = payload.content;
        let files = payload.files;

        if(!files || files?.length < 1 || !content) return;

        let response = await dispatch('uploadFiles', files, { root: true });
        content.files = content.files.concat(response);

        dispatch('updateContent', content);
    },
    async uploadContentItems({dispatch}, payload){
        let content = payload;
        let items = content.items;

        if(!items || items?.length < 1)
            return;

        dispatch("updateContent", content);
    },
    async removeContentFile({ dispatch}, payload){
        let content = payload.content;
        let file = payload.file;

        await dispatch('deleteFile', file.id, { root: true });

        content.files = content.files.filter(f => f.id != file.id);
        dispatch('updateContent', content);
    },
    async removeContentMedia({ dispatch}, payload){
        let content = payload.content;
        let image = payload.image;

        await dispatch('deleteMedia', image.id, { root: true });

        content.image = content.items.filter(i => i.id != image.id);
        dispatch('updateContent', content);
    }
}

const getters = {
    getArticle(state) {
        return state.article;
    },
    getSectionById: (state) => (sectionId) => { 
        return state.article.sections.find(s => s.id == sectionId);
    },
    getContentById: (state) => (contentId) => {
        if(contentId == null) return null;

        for (let index = 0; index < state.article.sections.length; index++) {
            let content = state.article.sections[index].contents.find(c => c.id == contentId);

            if (content)
                return content;
        }
        return null;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}